/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetOrderPaymentTypesAdminResponse } from '../models/GetOrderPaymentTypesAdminResponse';
import type { PutOrderPaymentTypeAdminRequest } from '../models/PutOrderPaymentTypeAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderPaymentTypesService {
    /**
     * **Required Policy:** `ViewOrderPaymentTypes`
     * @returns GetOrderPaymentTypesAdminResponse OK
     * @throws ApiError
     */
    public static getOrderPaymentTypesAdmin(): CancelablePromise<GetOrderPaymentTypesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orderpaymenttypes',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrderPaymentTypes`
     * @returns any OK
     * @throws ApiError
     */
    public static putOrderPaymentTypeAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutOrderPaymentTypeAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/orderpaymenttypes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
